import { atom } from 'jotai';

/**
 * Loading state of fragment (IFC) model layers, shown as badges in the
 * viewer's loading column (`ModelLoadingOverlay`).
 *
 * - `fetching`: the .frag file is downloading.
 * - `decoding`: downloaded; the fragments worker is still streaming geometry
 *   tiles in. `stage` tells the first build (`initial`) from a later burst
 *   after a zoom or pan (`refine`). See `fragmentStreamTracker.ts`.
 * - `failed`: stays until the layer is unloaded so the user sees why nothing
 *   appeared.
 */
export type ModelLoadingPhase = 'fetching' | 'decoding' | 'failed';

export interface ModelLoadingEntry {
  layerId: string;
  layerName: string;
  phase: ModelLoadingPhase;
  stage?: 'initial' | 'refine';
  /** 0..1 download progress, when the response carried a Content-Length. */
  progress?: number;
  loadedBytes?: number;
  totalBytes?: number;
  error?: string;
}

export const modelLoadingAtom = atom<Record<string, ModelLoadingEntry>>({});
